var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _rect, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBsrcomputotal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 607,
    height: 460.036,
    viewBox: "0 0 607 460.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.75,
    y1: 0.239,
    x2: 0.26,
    y2: 0.751,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--color-dark)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "var(--color-light)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "var(--color-semilight)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-semidark)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.007,
    y1: 0.313,
    x2: 0.983,
    y2: 0.306,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#60656a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#7f888f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#cfd9e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#7f888f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#60656a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.067,
    y1: 0.163,
    x2: 0.932,
    y2: 0.836,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#efe4bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbcbc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24612",
    "data-name": "Rect\\xE1ngulo 24612",
    width: 329.656,
    height: 244.133,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9707",
    "data-name": "Trazado 9707",
    d: "M30.993,191.087a3.258,3.258,0,0,0-2.489,1.156L.777,225.043a3.26,3.26,0,0,0,2.489,5.364H326.39a3.259,3.259,0,0,0,2.533-5.311l-26.547-32.8a3.262,3.262,0,0,0-2.534-1.209Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 1.349,
    x2: 0.003,
    y2: 1.349,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#55595f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#717b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727d85"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_24615",
    "data-name": "Rect\\xE1ngulo 24615",
    d: "M5,0H269.795a5,5,0,0,1,5,5V175.354a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(27.222 6.664)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9713",
    "data-name": "Trazado 9713",
    d: "M129.864,78.353a3.533,3.533,0,0,0-3.523,3.522l0,42.623a1.3,1.3,0,0,0,1.182,1.408,1.229,1.229,0,0,0,.227,0h71.331a1.389,1.389,0,0,0,1.409-1.369.252.252,0,0,0,0-.039V81.875a3.533,3.533,0,0,0-3.523-3.522Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24670",
    "data-name": "Rect\\xE1ngulo 24670",
    width: 72.912,
    height: 1.761,
    transform: "translate(126.867 78.355)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9715",
    "data-name": "Trazado 9715",
    d: "M126.338,116.045v8.1a1.665,1.665,0,0,0,1.561,1.761,1.683,1.683,0,0,0,.2,0h70.446a1.664,1.664,0,0,0,1.762-1.56,1.686,1.686,0,0,0,0-.2v-8.1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24673",
    "data-name": "Rect\\xE1ngulo 24673",
    width: 86.306,
    height: 113.246,
    transform: "translate(119.35 44.254)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24675",
    "data-name": "Rect\\xE1ngulo 24675",
    width: 296.824,
    height: 29.305,
    transform: "translate(15.986 197.697)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9721",
    "data-name": "Trazado 9721",
    d: "M309.873,227H18.927c-2.5,0-3.854-2.418-2.241-4L35.652,198.56a3.215,3.215,0,0,1,2.241-.862H291.964a3.2,3.2,0,0,1,2.282.9l17.9,24.443c1.561,1.592.2,3.961-2.273,3.961",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.075,
    y1: -1.563,
    x2: 1.065,
    y2: -1.568,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7e46d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#de950c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbb100"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_10077",
    x: 382.445,
    y: 376.5,
    width: 64.471,
    height: 16.478,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_10077-2",
    x: 382.445,
    y: 430.5,
    width: 64.471,
    height: 16.478,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_10077-3",
    x: 382.445,
    y: 419.5,
    width: 64.471,
    height: 16.478,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_10077-4",
    x: 382.445,
    y: 408.5,
    width: 64.471,
    height: 16.478,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_10077-5",
    x: 382.445,
    y: 398.5,
    width: 64.471,
    height: 16.478,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_10077-6",
    x: 382.445,
    y: 387.5,
    width: 64.471,
    height: 16.478,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.152,
    y1: 0.848,
    x2: 0.913,
    y2: 0.094,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec9829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#f4b40d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6b70d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.14,
    y1: 0.159,
    x2: 0.866,
    y2: 0.847,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#fad613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7dc15"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_99-2",
    x: 229.101,
    y: 16.364,
    width: 147.797,
    height: 147.272,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "img-bsrcomputotal",
    transform: "translate(0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9111",
    "data-name": "Grupo 9111",
    transform: "translate(784.762 -475.496)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9111-2",
    "data-name": "Grupo 9111",
    transform: "translate(-295.656 644.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5998",
    "data-name": "Trazado 5998",
    d: "M-71.65,782.984v11.6l-2.205.216a9.724,9.724,0,0,0-8.007,5.975l-.053.126A9.764,9.764,0,0,0-80.5,810.95l1.375,1.66-8.193,8.182-1.651-1.37A9.745,9.745,0,0,0-99,818l-.139.058a9.734,9.734,0,0,0-5.994,8.03l-.218,2.249H-116.96l-.22-2.266a9.732,9.732,0,0,0-5.99-8.029l-.129-.054a9.744,9.744,0,0,0-10.031,1.421l-1.663,1.38-8.194-8.182,1.361-1.642a9.766,9.766,0,0,0,1.412-10.058l-.054-.13a9.727,9.727,0,0,0-8.02-5.981l-2.276-.22v-11.6l2.3-.222a9.727,9.727,0,0,0,8.018-5.976c.016-.04.033-.08.05-.119a9.764,9.764,0,0,0-1.414-10.054l-1.375-1.659,8.194-8.182,1.651,1.37a9.745,9.745,0,0,0,10.034,1.42l.137-.057a9.734,9.734,0,0,0,5.993-8.03l.218-2.25h11.606l.22,2.266a9.732,9.732,0,0,0,5.991,8.029l.132.055a9.745,9.745,0,0,0,10.03-1.422l1.664-1.381,8.092,8.182-1.361,1.642A9.766,9.766,0,0,0-82,776.653l.054.13a9.727,9.727,0,0,0,8.02,5.981Z",
    transform: "translate(150.764 -749.224)",
    fill: "#999",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_24",
    "data-name": "Elipse 24",
    cx: 23.279,
    cy: 23.244,
    rx: 23.279,
    ry: 23.244,
    transform: "translate(16.279 16.314)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_25",
    "data-name": "Elipse 25",
    cx: 15.358,
    cy: 15.335,
    rx: 15.358,
    ry: 15.335,
    transform: "translate(24.199 24.223)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9112",
    "data-name": "Grupo 9112",
    transform: "translate(-392.273 573.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5999",
    "data-name": "Trazado 5999",
    d: "M-277.857,622.674v16.77l-3.189.313a14.063,14.063,0,0,0-11.58,8.641l-.076.182a14.119,14.119,0,0,0,2.045,14.539l1.989,2.4-11.849,11.832-2.388-1.982a14.093,14.093,0,0,0-14.51-2.054l-.2.084a14.076,14.076,0,0,0-8.669,11.613l-.315,3.252h-16.784l-.318-3.277a14.074,14.074,0,0,0-8.663-11.611l-.187-.078a14.092,14.092,0,0,0-14.508,2.055l-2.405,2-11.849-11.832,1.968-2.375a14.123,14.123,0,0,0,2.041-14.546l-.078-.187a14.067,14.067,0,0,0-11.6-8.65l-3.291-.319v-16.77l3.322-.322a14.065,14.065,0,0,0,11.6-8.643l.072-.172A14.12,14.12,0,0,0-379.327,599l-1.988-2.4,11.849-11.832,2.388,1.981a14.094,14.094,0,0,0,14.512,2.053l.2-.083A14.077,14.077,0,0,0-343.7,577.1l.315-3.254H-326.6l.318,3.276a14.075,14.075,0,0,0,8.664,11.611l.19.08a14.091,14.091,0,0,0,14.506-2.056l2.406-2,11.7,11.832-1.968,2.375a14.124,14.124,0,0,0-2.042,14.546l.079.188a14.066,14.066,0,0,0,11.6,8.649Z",
    transform: "translate(392.273 -573.851)",
    fill: "#999",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 33.666,
    cy: 33.615,
    rx: 33.666,
    ry: 33.615,
    transform: "translate(23.542 23.593)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_27",
    "data-name": "Elipse 27",
    cx: 22.211,
    cy: 22.177,
    rx: 22.211,
    ry: 22.177,
    transform: "translate(34.997 35.03)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9114",
    "data-name": "Grupo 9114",
    transform: "translate(-333.149 635.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9113",
    "data-name": "Grupo 9113",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10128",
    "data-name": "Rect\\xE1ngulo 10128",
    width: 60.008,
    height: 56.008,
    rx: 12.945,
    transform: "translate(0 0.095)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9329",
    "data-name": "Trazado 9329",
    d: "M12,0H48.007a12,12,0,0,1,12,12H0A12,12,0,0,1,12,0Z",
    fill: "var(--color-primary)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6000",
    "data-name": "Trazado 6000",
    d: "M-206.9,770.3a1.2,1.2,0,0,1-.364.884l-9.411,9.411-1.768,1.768a1.2,1.2,0,0,1-.884.364,1.2,1.2,0,0,1-.884-.364l-1.768-1.768-4.705-4.705a1.2,1.2,0,0,1-.364-.884,1.2,1.2,0,0,1,.364-.884l1.768-1.768a1.2,1.2,0,0,1,.884-.364,1.2,1.2,0,0,1,.884.364l3.821,3.835,8.527-8.54a1.2,1.2,0,0,1,.884-.364,1.2,1.2,0,0,1,.884.364l1.767,1.767A1.2,1.2,0,0,1-206.9,770.3Z",
    transform: "translate(234.02 -751.16)",
    fill: "var(--color-primary)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6001",
    "data-name": "Trazado 6001",
    d: "M-206.9,814.222a1.2,1.2,0,0,1-.364.884l-9.411,9.411-1.768,1.768a1.2,1.2,0,0,1-.884.364,1.2,1.2,0,0,1-.884-.364l-1.768-1.768-4.705-4.706a1.2,1.2,0,0,1-.364-.884,1.2,1.2,0,0,1,.364-.884l1.768-1.768a1.2,1.2,0,0,1,.884-.364,1.2,1.2,0,0,1,.884.364l3.821,3.835,8.527-8.54a1.2,1.2,0,0,1,.884-.364,1.2,1.2,0,0,1,.884.364l1.767,1.768A1.2,1.2,0,0,1-206.9,814.222Z",
    transform: "translate(234.02 -777.512)",
    fill: "var(--color-primary)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13016",
    "data-name": "Grupo 13016",
    transform: "translate(1309 -1887)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12988",
    "data-name": "Grupo 12988",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12987",
    "data-name": "Grupo 12987",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9706",
    "data-name": "Trazado 9706",
    d: "M326.364,230.407H3.24S1.4,228.4,0,227.007L.038,237.67a6.435,6.435,0,0,0,6.434,6.411l316.748.052a6.435,6.435,0,0,0,6.436-6.432v-.026l-.034-10.616a6.516,6.516,0,0,0-3.258,3.348",
    fill: "#929aa1"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12990",
    "data-name": "Grupo 12990",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12989",
    "data-name": "Grupo 12989",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24613",
    "data-name": "Rect\\xE1ngulo 24613",
    width: 330.05,
    height: 39.32,
    transform: "translate(0.006 191.087)",
    fill: "url(#linear-gradient-7)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12992",
    "data-name": "Grupo 12992",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12991",
    "data-name": "Grupo 12991",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9708",
    "data-name": "Trazado 9708",
    d: "M34.794,0h259.65a13.741,13.741,0,0,1,13.742,13.742v166.2a13.742,13.742,0,0,1-13.742,13.742H34.794a13.742,13.742,0,0,1-13.742-13.742V13.742A13.741,13.741,0,0,1,34.794,0",
    fill: "#a0a9b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9709",
    "data-name": "Trazado 9709",
    d: "M194.185,236.229H135.469a5.9,5.9,0,0,1-5.9-5.894h70.51a5.9,5.9,0,0,1-5.9,5.9Z",
    fill: "#4b4b4b"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12994",
    "data-name": "Grupo 12994",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12993",
    "data-name": "Grupo 12993",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9710",
    "data-name": "Trazado 9710",
    d: "M174.692-80.778l-288.4,171.009,268.259,184.23,288.4-171.009Z",
    fill: "url(#linear-gradient)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12996",
    "data-name": "Grupo 12996",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12995",
    "data-name": "Grupo 12995",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24616",
    "data-name": "Rect\\xE1ngulo 24616",
    width: 8.022,
    height: 4.387,
    transform: "translate(54.543 22.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24617",
    "data-name": "Rect\\xE1ngulo 24617",
    width: 37.705,
    height: 4.387,
    transform: "translate(70.588 22.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24618",
    "data-name": "Rect\\xE1ngulo 24618",
    width: 2.808,
    height: 4.387,
    transform: "translate(48.393 22.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24619",
    "data-name": "Rect\\xE1ngulo 24619",
    width: 8.022,
    height: 4.387,
    transform: "translate(54.543 34.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24620",
    "data-name": "Rect\\xE1ngulo 24620",
    width: 37.705,
    height: 4.387,
    transform: "translate(70.588 34.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24621",
    "data-name": "Rect\\xE1ngulo 24621",
    width: 2.808,
    height: 4.387,
    transform: "translate(48.393 34.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24622",
    "data-name": "Rect\\xE1ngulo 24622",
    width: 8.022,
    height: 4.387,
    transform: "translate(54.543 46.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24623",
    "data-name": "Rect\\xE1ngulo 24623",
    width: 37.705,
    height: 4.387,
    transform: "translate(70.588 46.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24624",
    "data-name": "Rect\\xE1ngulo 24624",
    width: 2.808,
    height: 4.387,
    transform: "translate(48.393 46.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24625",
    "data-name": "Rect\\xE1ngulo 24625",
    width: 8.022,
    height: 4.387,
    transform: "translate(54.543 58.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24626",
    "data-name": "Rect\\xE1ngulo 24626",
    width: 37.705,
    height: 4.387,
    transform: "translate(70.588 58.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24627",
    "data-name": "Rect\\xE1ngulo 24627",
    width: 2.808,
    height: 4.387,
    transform: "translate(48.393 58.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24628",
    "data-name": "Rect\\xE1ngulo 24628",
    width: 18.986,
    height: 4.387,
    transform: "translate(43.579 70.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24629",
    "data-name": "Rect\\xE1ngulo 24629",
    width: 48.401,
    height: 4.387,
    transform: "translate(70.587 70.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24630",
    "data-name": "Rect\\xE1ngulo 24630",
    width: 11.364,
    height: 4.387,
    transform: "translate(51.201 82.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24631",
    "data-name": "Rect\\xE1ngulo 24631",
    width: 53.571,
    height: 4.387,
    transform: "translate(70.588 82.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24632",
    "data-name": "Rect\\xE1ngulo 24632",
    width: 8.022,
    height: 4.387,
    transform: "translate(218.686 104.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24633",
    "data-name": "Rect\\xE1ngulo 24633",
    width: 37.705,
    height: 4.387,
    transform: "translate(234.73 104.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24634",
    "data-name": "Rect\\xE1ngulo 24634",
    width: 2.808,
    height: 4.387,
    transform: "translate(212.536 104.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24635",
    "data-name": "Rect\\xE1ngulo 24635",
    width: 8.022,
    height: 4.387,
    transform: "translate(218.686 116.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24636",
    "data-name": "Rect\\xE1ngulo 24636",
    width: 21.349,
    height: 4.387,
    transform: "translate(234.73 116.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24637",
    "data-name": "Rect\\xE1ngulo 24637",
    width: 2.808,
    height: 4.387,
    transform: "translate(212.536 116.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24638",
    "data-name": "Rect\\xE1ngulo 24638",
    width: 8.022,
    height: 4.387,
    transform: "translate(218.686 128.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24639",
    "data-name": "Rect\\xE1ngulo 24639",
    width: 46.574,
    height: 4.387,
    transform: "translate(234.73 128.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24640",
    "data-name": "Rect\\xE1ngulo 24640",
    width: 2.808,
    height: 4.387,
    transform: "translate(212.536 128.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24641",
    "data-name": "Rect\\xE1ngulo 24641",
    width: 8.022,
    height: 4.387,
    transform: "translate(218.686 140.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24642",
    "data-name": "Rect\\xE1ngulo 24642",
    width: 30.975,
    height: 4.387,
    transform: "translate(234.73 140.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24643",
    "data-name": "Rect\\xE1ngulo 24643",
    width: 2.808,
    height: 4.387,
    transform: "translate(212.536 140.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24644",
    "data-name": "Rect\\xE1ngulo 24644",
    width: 8.022,
    height: 4.387,
    transform: "translate(54.543 106.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24645",
    "data-name": "Rect\\xE1ngulo 24645",
    width: 37.705,
    height: 4.387,
    transform: "translate(70.588 106.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24646",
    "data-name": "Rect\\xE1ngulo 24646",
    width: 2.808,
    height: 4.387,
    transform: "translate(48.393 106.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24647",
    "data-name": "Rect\\xE1ngulo 24647",
    width: 20.055,
    height: 4.387,
    transform: "translate(42.51 118.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24648",
    "data-name": "Rect\\xE1ngulo 24648",
    width: 44.122,
    height: 4.387,
    transform: "translate(70.588 118.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24649",
    "data-name": "Rect\\xE1ngulo 24649",
    width: 8.022,
    height: 4.387,
    transform: "translate(54.543 142.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24650",
    "data-name": "Rect\\xE1ngulo 24650",
    width: 37.705,
    height: 4.387,
    transform: "translate(70.588 142.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24651",
    "data-name": "Rect\\xE1ngulo 24651",
    width: 2.808,
    height: 4.387,
    transform: "translate(48.393 142.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24652",
    "data-name": "Rect\\xE1ngulo 24652",
    width: 8.022,
    height: 4.387,
    transform: "translate(54.543 154.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24653",
    "data-name": "Rect\\xE1ngulo 24653",
    width: 37.705,
    height: 4.387,
    transform: "translate(70.588 154.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24654",
    "data-name": "Rect\\xE1ngulo 24654",
    width: 2.808,
    height: 4.387,
    transform: "translate(48.393 154.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24655",
    "data-name": "Rect\\xE1ngulo 24655",
    width: 8.022,
    height: 4.387,
    transform: "translate(54.543 166.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24656",
    "data-name": "Rect\\xE1ngulo 24656",
    width: 37.705,
    height: 4.387,
    transform: "translate(70.588 166.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24657",
    "data-name": "Rect\\xE1ngulo 24657",
    width: 2.808,
    height: 4.387,
    transform: "translate(48.393 166.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24658",
    "data-name": "Rect\\xE1ngulo 24658",
    width: 9.627,
    height: 4.387,
    transform: "translate(206.363 30.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24659",
    "data-name": "Rect\\xE1ngulo 24659",
    width: 50.674,
    height: 4.387,
    transform: "translate(222.675 30.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24660",
    "data-name": "Rect\\xE1ngulo 24660",
    width: 6.017,
    height: 4.387,
    transform: "translate(278.296 30.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24661",
    "data-name": "Rect\\xE1ngulo 24661",
    width: 9.627,
    height: 4.387,
    transform: "translate(206.363 42.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24662",
    "data-name": "Rect\\xE1ngulo 24662",
    width: 50.674,
    height: 4.387,
    transform: "translate(222.675 42.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24663",
    "data-name": "Rect\\xE1ngulo 24663",
    width: 6.017,
    height: 4.387,
    transform: "translate(278.296 42.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24664",
    "data-name": "Rect\\xE1ngulo 24664",
    width: 9.627,
    height: 4.387,
    transform: "translate(206.363 54.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24665",
    "data-name": "Rect\\xE1ngulo 24665",
    width: 34.562,
    height: 4.387,
    transform: "translate(222.675 54.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24666",
    "data-name": "Rect\\xE1ngulo 24666",
    width: 9.627,
    height: 4.387,
    transform: "translate(206.363 67.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24667",
    "data-name": "Rect\\xE1ngulo 24667",
    width: 25.337,
    height: 4.387,
    transform: "translate(222.675 67.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9711",
    "data-name": "Trazado 9711",
    d: "M153.46,71.31h-23.6a3.534,3.534,0,0,0-3.523,3.523V119.39a1.2,1.2,0,0,0,1.166,1.233h71.575a1.2,1.2,0,0,0,1.233-1.166c0-.022,0-.045,0-.067V81.875a3.533,3.533,0,0,0-3.523-3.522H162.269a5.066,5.066,0,0,1-3.7-1.585l-2.994-4.579a2.638,2.638,0,0,0-2.115-.879",
    fill: "#f7b90d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_8",
    "data-name": "L\\xEDnea 8",
    x2: 73.97,
    transform: "translate(126.338 123.265)",
    fill: "none",
    stroke: "#da7b15",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_9",
    "data-name": "L\\xEDnea 9",
    x2: 73.97,
    transform: "translate(126.338 121.504)",
    fill: "none",
    stroke: "#da7b15",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_10",
    "data-name": "L\\xEDnea 10",
    x2: 73.97,
    transform: "translate(126.338 119.742)",
    fill: "none",
    stroke: "#da7b15",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9712",
    "data-name": "Trazado 9712",
    d: "M126.338,124.5a1.3,1.3,0,0,0,1.182,1.408,1.229,1.229,0,0,0,.227,0h71.331a1.389,1.389,0,0,0,1.409-1.369V81.875a3.533,3.533,0,0,0-3.523-3.522h-67.1a3.533,3.533,0,0,0-3.523,3.522Z",
    fill: "#f9d75e"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12998",
    "data-name": "Grupo 12998",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12997",
    "data-name": "Grupo 12997",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_24669",
    "data-name": "Rect\\xE1ngulo 24669",
    width: 75,
    height: 48,
    transform: "translate(126 78.133)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAwCAYAAABZq4foAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAS6ADAAQAAAABAAAAMAAAAAApwZRfAAAArUlEQVRoBe3SsQ3AIAADQWDQ7MGkmSUdUibg+3P91cnze5897EpgXVWiXwBWOAIsWEEgpJ4FKwiE1LNgBYGQehasIBBSz4IVBELqWbCCQEg9C1YQCKlnwQoCIfUsWEEgpJ4FKwiE1LNgBYGQehasIBBSz4IVBELqWbCCQEg9C1YQCKlnwQoCIfUsWEEgpJ4FKwiE1LNgBYGQehasIBBSz4IVBELqWbCCQEg9K2AdgjsDB4xmSRIAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13003",
    "data-name": "Grupo 13003",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13002",
    "data-name": "Grupo 13002",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13001",
    "data-name": "Grupo 13001",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13000",
    "data-name": "Grupo 13000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12999",
    "data-name": "Grupo 12999",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9714",
    "data-name": "Trazado 9714",
    d: "M196.785,80.116h2.994a3.63,3.63,0,0,0-2.994-1.761H129.861c-1.938,0-2.642.881-2.994,1.761Z",
    fill: "#fff"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13005",
    "data-name": "Grupo 13005",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13004",
    "data-name": "Grupo 13004",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_24672",
    "data-name": "Rect\\xE1ngulo 24672",
    width: 75,
    height: 11,
    transform: "translate(126 115.133)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAALCAYAAAA3FnCGAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAS6ADAAQAAAABAAAACwAAAAD/MB3IAAAAXElEQVRIDe3WuRGAMAxE0YVRE6Y5uncJ2JkQHaxivuN18nSMjswUzxMIzfv0oqRCe10weAKF9YDlWSm0wDKtCosxdK3oLFuqgl9njc6HP2dZ8I3qs+BbWJwONtcLE4oWtZrnX48AAAAASUVORK5CYII="
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13015",
    "data-name": "Grupo 13015",
    transform: "translate(-1171 2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13014",
    "data-name": "Grupo 13014",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13008",
    "data-name": "Grupo 13008",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13007",
    "data-name": "Grupo 13007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13006",
    "data-name": "Grupo 13006",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9716",
    "data-name": "Trazado 9716",
    d: "M156.787,91.145h-1.069V56.023H144.51L134.1,45.354h-7.533v-1.1h7.977L144.95,54.925h11.835Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9717",
    "data-name": "Trazado 9717",
    d: "M133.744,114.175H120.42v-1.1H133.3L143.71,102.4h12.545v1.1h-12.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9718",
    "data-name": "Trazado 9718",
    d: "M141.637,157.5H119.35v-1.1h21.84l25.648-26.3V110.521h1.069v20.038Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9719",
    "data-name": "Trazado 9719",
    d: "M176.621,89.316h-1.069V59.34L190.26,44.258h6.994v1.1H190.7L176.622,59.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9720",
    "data-name": "Trazado 9720",
    d: "M205.656,128.983H194.178l-14.929-15.308V102.957h1.07v10.261l14.3,14.668h11.032Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13013",
    "data-name": "Grupo 13013",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13012",
    "data-name": "Grupo 13012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13011",
    "data-name": "Grupo 13011",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13010",
    "data-name": "Grupo 13010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13009",
    "data-name": "Grupo 13009",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24674",
    "data-name": "Rect\\xE1ngulo 24674",
    width: 298.634,
    height: 29.319,
    transform: "translate(15.073 197.683)",
    fill: "url(#linear-gradient-2)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9722",
    "data-name": "Trazado 9722",
    d: "M57.881,208.324H41.043l2.287-3.51H59.843Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9723",
    "data-name": "Trazado 9723",
    d: "M77.078,208.324H60.24l1.916-3.51H78.669Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9724",
    "data-name": "Trazado 9724",
    d: "M96.276,208.324H79.438l1.545-3.51H97.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9725",
    "data-name": "Trazado 9725",
    d: "M115.473,208.324H98.635l1.174-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9726",
    "data-name": "Trazado 9726",
    d: "M134.671,208.324H117.832l.8-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9727",
    "data-name": "Trazado 9727",
    d: "M153.868,208.324H137.03l.431-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9728",
    "data-name": "Trazado 9728",
    d: "M173.065,208.324H156.227l.06-3.51H172.8Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9729",
    "data-name": "Trazado 9729",
    d: "M192.263,208.324H175.425l-.311-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9730",
    "data-name": "Trazado 9730",
    d: "M211.46,208.324H194.622l-.682-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9731",
    "data-name": "Trazado 9731",
    d: "M230.658,208.324H213.819l-1.053-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9732",
    "data-name": "Trazado 9732",
    d: "M249.855,208.324H233.017l-1.424-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9733",
    "data-name": "Trazado 9733",
    d: "M269.052,208.324H252.214l-1.795-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9734",
    "data-name": "Trazado 9734",
    d: "M288.25,208.324H271.412l-2.166-3.51h16.513Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9735",
    "data-name": "Trazado 9735",
    d: "M88.63,203.252H72.262l1.638-3.319H89.96Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9736",
    "data-name": "Trazado 9736",
    d: "M107.2,203.252H90.833l1.289-3.319h16.06Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9737",
    "data-name": "Trazado 9737",
    d: "M125.771,203.252H109.4l.939-3.319H126.4Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9738",
    "data-name": "Trazado 9738",
    d: "M144.342,203.252H127.974l.59-3.319h16.061Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9739",
    "data-name": "Trazado 9739",
    d: "M162.913,203.252H146.544l.241-3.319h16.06Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9740",
    "data-name": "Trazado 9740",
    d: "M181.483,203.252H165.115l-.108-3.319h16.06Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9741",
    "data-name": "Trazado 9741",
    d: "M200.054,203.252H183.686l-.457-3.319h16.06Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9742",
    "data-name": "Trazado 9742",
    d: "M218.624,203.252H202.256l-.806-3.319h16.06Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9743",
    "data-name": "Trazado 9743",
    d: "M237.195,203.252H220.827l-1.156-3.319h16.061Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9744",
    "data-name": "Trazado 9744",
    d: "M255.766,203.252H239.4l-1.5-3.319h16.061Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9745",
    "data-name": "Trazado 9745",
    d: "M288.943,225.677H49.488l2.562-4.638H285.922Z",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9746",
    "data-name": "Trazado 9746",
    d: "M44.716,219.394H26.851l2.715-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9747",
    "data-name": "Trazado 9747",
    d: "M66.273,219.394H48.408l2.273-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9748",
    "data-name": "Trazado 9748",
    d: "M87.831,219.394H69.966l1.832-3.946H89.3Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9749",
    "data-name": "Trazado 9749",
    d: "M109.389,219.394H91.524l1.39-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9750",
    "data-name": "Trazado 9750",
    d: "M130.946,219.394H113.081l.948-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9751",
    "data-name": "Trazado 9751",
    d: "M152.5,219.394H134.639l.507-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9752",
    "data-name": "Trazado 9752",
    d: "M174.061,219.394H156.2l.065-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9753",
    "data-name": "Trazado 9753",
    d: "M195.619,219.394H177.754l-.377-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9754",
    "data-name": "Trazado 9754",
    d: "M217.176,219.394H199.311l-.818-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9755",
    "data-name": "Trazado 9755",
    d: "M238.734,219.394H220.869l-1.26-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9756",
    "data-name": "Trazado 9756",
    d: "M260.292,219.394H242.426l-1.7-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9757",
    "data-name": "Trazado 9757",
    d: "M281.849,219.394H263.984l-2.143-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9758",
    "data-name": "Trazado 9758",
    d: "M303.407,219.394H285.542l-2.585-3.946h17.5Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9759",
    "data-name": "Trazado 9759",
    d: "M45.106,213.695H27.769l2.618-3.719H47.379Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9760",
    "data-name": "Trazado 9760",
    d: "M64.775,213.695H47.438l2.227-3.719H66.657Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9761",
    "data-name": "Trazado 9761",
    d: "M84.445,213.695H67.108l1.836-3.719H85.935Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9762",
    "data-name": "Trazado 9762",
    d: "M104.114,213.695H86.777l1.444-3.719h16.992Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9763",
    "data-name": "Trazado 9763",
    d: "M123.783,213.695H106.446l1.053-3.719h16.992Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9764",
    "data-name": "Trazado 9764",
    d: "M143.453,213.695H126.116l.662-3.719H143.77Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9765",
    "data-name": "Trazado 9765",
    d: "M163.122,213.695H145.785l.271-3.719h16.991Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9766",
    "data-name": "Trazado 9766",
    d: "M182.791,213.695H165.454l-.121-3.719h16.992Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9767",
    "data-name": "Trazado 9767",
    d: "M202.461,213.695H185.124l-.512-3.719H201.6Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9768",
    "data-name": "Trazado 9768",
    d: "M222.13,213.695H204.793l-.9-3.719h16.992Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9769",
    "data-name": "Trazado 9769",
    d: "M241.8,213.695H224.462l-1.294-3.719h16.991Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9770",
    "data-name": "Trazado 9770",
    d: "M261.469,213.695H244.132l-1.686-3.719h16.992Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9771",
    "data-name": "Trazado 9771",
    d: "M281.138,213.695H263.8l-2.077-3.719h16.992Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9772",
    "data-name": "Trazado 9772",
    d: "M300.807,213.695H283.47L281,209.976h16.991Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9773",
    "data-name": "Trazado 9773",
    d: "M57.881,207.324H41.043l2.287-3.51H59.843Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9774",
    "data-name": "Trazado 9774",
    d: "M77.078,207.324H60.24l1.916-3.51H78.669Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9775",
    "data-name": "Trazado 9775",
    d: "M96.276,207.324H79.438l1.545-3.51H97.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9776",
    "data-name": "Trazado 9776",
    d: "M115.473,207.324H98.635l1.174-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9777",
    "data-name": "Trazado 9777",
    d: "M134.671,207.324H117.832l.8-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9778",
    "data-name": "Trazado 9778",
    d: "M153.868,207.324H137.03l.431-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9779",
    "data-name": "Trazado 9779",
    d: "M173.065,207.324H156.227l.06-3.51H172.8Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9780",
    "data-name": "Trazado 9780",
    d: "M192.263,207.324H175.425l-.311-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9781",
    "data-name": "Trazado 9781",
    d: "M211.46,207.324H194.622l-.682-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9782",
    "data-name": "Trazado 9782",
    d: "M230.658,207.324H213.819l-1.053-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9783",
    "data-name": "Trazado 9783",
    d: "M249.855,207.324H233.017l-1.424-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9784",
    "data-name": "Trazado 9784",
    d: "M269.052,207.324H252.214l-1.795-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9785",
    "data-name": "Trazado 9785",
    d: "M288.25,207.324H271.412l-2.166-3.51h16.513Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9786",
    "data-name": "Trazado 9786",
    d: "M88.63,202.252H72.262l1.638-3.319H89.96Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9787",
    "data-name": "Trazado 9787",
    d: "M107.2,202.252H90.833l1.289-3.319h16.06Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9788",
    "data-name": "Trazado 9788",
    d: "M125.771,202.252H109.4l.939-3.319H126.4Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9789",
    "data-name": "Trazado 9789",
    d: "M144.342,202.252H127.974l.59-3.319h16.061Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9790",
    "data-name": "Trazado 9790",
    d: "M162.913,202.252H146.544l.241-3.319h16.06Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9791",
    "data-name": "Trazado 9791",
    d: "M181.483,202.252H165.115l-.108-3.319h16.06Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9792",
    "data-name": "Trazado 9792",
    d: "M200.054,202.252H183.686l-.457-3.319h16.06Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9793",
    "data-name": "Trazado 9793",
    d: "M218.624,202.252H202.256l-.806-3.319h16.06Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9794",
    "data-name": "Trazado 9794",
    d: "M237.195,202.252H220.827l-1.156-3.319h16.061Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9795",
    "data-name": "Trazado 9795",
    d: "M255.766,202.252H239.4l-1.5-3.319h16.061Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9796",
    "data-name": "Trazado 9796",
    d: "M288.943,224.677H49.488l2.562-4.638H285.922Z",
    fill: "#515b62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9797",
    "data-name": "Trazado 9797",
    d: "M44.716,218.394H26.851l2.715-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9798",
    "data-name": "Trazado 9798",
    d: "M66.273,218.394H48.408l2.273-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9799",
    "data-name": "Trazado 9799",
    d: "M87.831,218.394H69.966l1.832-3.946H89.3Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9800",
    "data-name": "Trazado 9800",
    d: "M109.389,218.394H91.524l1.39-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9801",
    "data-name": "Trazado 9801",
    d: "M130.946,218.394H113.081l.948-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9802",
    "data-name": "Trazado 9802",
    d: "M152.5,218.394H134.639l.507-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9803",
    "data-name": "Trazado 9803",
    d: "M174.061,218.394H156.2l.065-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9804",
    "data-name": "Trazado 9804",
    d: "M195.619,218.394H177.754l-.377-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9805",
    "data-name": "Trazado 9805",
    d: "M217.176,218.394H199.311l-.818-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9806",
    "data-name": "Trazado 9806",
    d: "M238.734,218.394H220.869l-1.26-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9807",
    "data-name": "Trazado 9807",
    d: "M260.292,218.394H242.426l-1.7-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9808",
    "data-name": "Trazado 9808",
    d: "M281.849,218.394H263.984l-2.143-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9809",
    "data-name": "Trazado 9809",
    d: "M303.407,218.394H285.542l-2.585-3.946h17.5Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9810",
    "data-name": "Trazado 9810",
    d: "M45.106,212.695H27.769l2.618-3.719H47.379Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9811",
    "data-name": "Trazado 9811",
    d: "M64.775,212.695H47.438l2.227-3.719H66.657Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9812",
    "data-name": "Trazado 9812",
    d: "M84.445,212.695H67.108l1.836-3.719H85.935Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9813",
    "data-name": "Trazado 9813",
    d: "M104.114,212.695H86.777l1.444-3.719h16.992Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9814",
    "data-name": "Trazado 9814",
    d: "M123.783,212.695H106.446l1.053-3.719h16.992Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9815",
    "data-name": "Trazado 9815",
    d: "M143.453,212.695H126.116l.662-3.719H143.77Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9816",
    "data-name": "Trazado 9816",
    d: "M163.122,212.695H145.785l.271-3.719h16.991Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9817",
    "data-name": "Trazado 9817",
    d: "M182.791,212.695H165.454l-.121-3.719h16.992Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9818",
    "data-name": "Trazado 9818",
    d: "M202.461,212.695H185.124l-.512-3.719H201.6Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9819",
    "data-name": "Trazado 9819",
    d: "M222.13,212.695H204.793l-.9-3.719h16.992Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9820",
    "data-name": "Trazado 9820",
    d: "M241.8,212.695H224.462l-1.294-3.719h16.991Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9821",
    "data-name": "Trazado 9821",
    d: "M261.469,212.695H244.132l-1.686-3.719h16.992Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9822",
    "data-name": "Trazado 9822",
    d: "M281.138,212.695H263.8l-2.077-3.719h16.992Z",
    fill: "#5c666e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9823",
    "data-name": "Trazado 9823",
    d: "M300.807,212.695H283.47L281,208.976h16.991Z",
    fill: "#5c666e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24677",
    "data-name": "Rect\\xE1ngulo 24677",
    width: 329.656,
    height: 244.133,
    transform: "translate(-1171 2017)",
    fill: "none"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9014",
    "data-name": "Grupo 9014",
    transform: "translate(0 146.81)",
    opacity: 0.998
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9013",
    "data-name": "Grupo 9013",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10061",
    "data-name": "Rect\\xE1ngulo 10061",
    width: 180.257,
    height: 105.215,
    rx: 4.988,
    transform: "translate(180.257 105.215) rotate(180)",
    opacity: 0.999,
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9012",
    "data-name": "Grupo 9012",
    transform: "translate(18.664 16.898)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9000",
    "data-name": "Grupo 9000",
    transform: "translate(-9.435 -5.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8994",
    "data-name": "Grupo 8994",
    transform: "translate(7.772 6.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8992",
    "data-name": "Grupo 8992",
    transform: "translate(7.45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 15.259,
    cy: 15.259,
    r: 15.259,
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8993",
    "data-name": "Grupo 8993",
    transform: "translate(0 35.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_10062",
    "data-name": "Rect\\xE1ngulo 10062",
    d: "M11.54,0H33.879a11.54,11.54,0,0,1,11.54,11.54V34.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V11.54A11.54,11.54,0,0,1,11.54,0Z",
    fill: "#999"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9004",
    "data-name": "Grupo 9004",
    transform: "translate(64.666 36.068)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10068",
    "data-name": "Rect\\xE1ngulo 10068",
    width: 5.38,
    height: 4.783,
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9005",
    "data-name": "Grupo 9005",
    transform: "translate(75.925 36.068)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10069",
    "data-name": "Rect\\xE1ngulo 10069",
    width: 26.204,
    height: 4.783,
    transform: "translate(0 0)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9006",
    "data-name": "Grupo 9006",
    transform: "translate(64.666 45.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10070",
    "data-name": "Rect\\xE1ngulo 10070",
    width: 5.38,
    height: 4.782,
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9007",
    "data-name": "Grupo 9007",
    transform: "translate(75.925 45.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10071",
    "data-name": "Rect\\xE1ngulo 10071",
    width: 47.164,
    height: 5.782,
    transform: "translate(0 0)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9008",
    "data-name": "Grupo 9008",
    transform: "translate(64.666 55.596)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10072",
    "data-name": "Rect\\xE1ngulo 10072",
    width: 5.38,
    height: 4.783,
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9009",
    "data-name": "Grupo 9009",
    transform: "translate(75.925 55.596)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10073",
    "data-name": "Rect\\xE1ngulo 10073",
    width: 69.2,
    height: 4.783,
    transform: "translate(0)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9010",
    "data-name": "Grupo 9010",
    transform: "translate(64.666 65.361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10074",
    "data-name": "Rect\\xE1ngulo 10074",
    width: 5.38,
    height: 4.782,
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9011",
    "data-name": "Grupo 9011",
    transform: "translate(75.925 65.361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10075",
    "data-name": "Rect\\xE1ngulo 10075",
    width: 45.437,
    height: 4.782,
    transform: "translate(0 0)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10117",
    "data-name": "Rect\\xE1ngulo 10117",
    width: 80.459,
    height: 4.782,
    transform: "translate(64.666 1.093)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10118",
    "data-name": "Rect\\xE1ngulo 10118",
    width: 80.459,
    height: 4.782,
    transform: "translate(64.666 10.093)",
    fill: "#999"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9051",
    "data-name": "Grupo 9051",
    transform: "translate(369.589 363.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10076",
    "data-name": "Rect\\xE1ngulo 10076",
    width: 237.411,
    height: 96.382,
    rx: 3.941,
    fill: "#f4f4f4",
    opacity: 0.552
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9021",
    "data-name": "Grupo 9021",
    transform: "translate(16.56 16.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9020",
    "data-name": "Grupo 9020",
    transform: "translate(0.796 0.797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -386.95, -381)",
    filter: "url(#Rect\\xE1ngulo_10077)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10077-7",
    "data-name": "Rect\\xE1ngulo 10077",
    width: 55.471,
    height: 7.478,
    transform: "translate(386.95 381)",
    fill: "url(#linear-gradient-11)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9089",
    "data-name": "Grupo 9089",
    transform: "translate(16.56 70.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9020-2",
    "data-name": "Grupo 9020",
    transform: "translate(0.796 0.797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -386.95, -435)",
    filter: "url(#Rect\\xE1ngulo_10077-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10077-8",
    "data-name": "Rect\\xE1ngulo 10077",
    width: 55.471,
    height: 7.478,
    transform: "translate(386.95 435)",
    fill: "url(#linear-gradient-11)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9090",
    "data-name": "Grupo 9090",
    transform: "translate(16.56 59.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9020-3",
    "data-name": "Grupo 9020",
    transform: "translate(0.796 0.797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -386.95, -424)",
    filter: "url(#Rect\\xE1ngulo_10077-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10077-9",
    "data-name": "Rect\\xE1ngulo 10077",
    width: 55.471,
    height: 7.478,
    transform: "translate(386.95 424)",
    fill: "url(#linear-gradient-11)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9091",
    "data-name": "Grupo 9091",
    transform: "translate(16.56 48.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9020-4",
    "data-name": "Grupo 9020",
    transform: "translate(0.796 0.797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -386.95, -413)",
    filter: "url(#Rect\\xE1ngulo_10077-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10077-10",
    "data-name": "Rect\\xE1ngulo 10077",
    width: 55.471,
    height: 7.478,
    transform: "translate(386.95 413)",
    fill: "url(#linear-gradient-11)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9092",
    "data-name": "Grupo 9092",
    transform: "translate(16.56 38.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9020-5",
    "data-name": "Grupo 9020",
    transform: "translate(0.796 0.797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -386.95, -403)",
    filter: "url(#Rect\\xE1ngulo_10077-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10077-11",
    "data-name": "Rect\\xE1ngulo 10077",
    width: 55.471,
    height: 7.478,
    transform: "translate(386.95 403)",
    fill: "url(#linear-gradient-11)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9093",
    "data-name": "Grupo 9093",
    transform: "translate(16.56 27.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9020-6",
    "data-name": "Grupo 9020",
    transform: "translate(0.796 0.797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -386.95, -392)",
    filter: "url(#Rect\\xE1ngulo_10077-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10077-12",
    "data-name": "Rect\\xE1ngulo 10077",
    width: 55.471,
    height: 7.478,
    transform: "translate(386.95 392)",
    fill: "url(#linear-gradient-11)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9022",
    "data-name": "Grupo 9022",
    transform: "translate(92.957 17.069)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10078",
    "data-name": "Rect\\xE1ngulo 10078",
    width: 34.464,
    height: 5.67,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9023",
    "data-name": "Grupo 9023",
    transform: "translate(92.957 27.935)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10079",
    "data-name": "Rect\\xE1ngulo 10079",
    width: 72.497,
    height: 5.67,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9024",
    "data-name": "Grupo 9024",
    transform: "translate(92.957 38.802)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10080",
    "data-name": "Rect\\xE1ngulo 10080",
    width: 72.497,
    height: 5.67,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9025",
    "data-name": "Grupo 9025",
    transform: "translate(92.957 49.669)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10081",
    "data-name": "Rect\\xE1ngulo 10081",
    width: 54.071,
    height: 5.669,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9032",
    "data-name": "Grupo 9032",
    transform: "translate(92.957 64.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9026",
    "data-name": "Grupo 9026"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10082",
    "data-name": "Rect\\xE1ngulo 10082",
    width: 8.479,
    height: 4.252,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9027",
    "data-name": "Grupo 9027",
    transform: "translate(14.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10083",
    "data-name": "Rect\\xE1ngulo 10083",
    width: 32.81,
    height: 4.252,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9028",
    "data-name": "Grupo 9028",
    transform: "translate(55.041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10084",
    "data-name": "Rect\\xE1ngulo 10084",
    width: 27.851,
    height: 4.252,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9029",
    "data-name": "Grupo 9029",
    transform: "translate(0 10.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10085",
    "data-name": "Rect\\xE1ngulo 10085",
    width: 8.479,
    height: 4.252,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9030",
    "data-name": "Grupo 9030",
    transform: "translate(14.882 10.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10086",
    "data-name": "Rect\\xE1ngulo 10086",
    width: 32.81,
    height: 4.252,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9031",
    "data-name": "Grupo 9031",
    transform: "translate(55.041 10.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10087",
    "data-name": "Rect\\xE1ngulo 10087",
    width: 17.456,
    height: 4.252,
    fill: "#f4f4f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9034",
    "data-name": "Grupo 9034",
    transform: "translate(194.865 18.204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10089",
    "data-name": "Rect\\xE1ngulo 10089",
    width: 4.489,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9035",
    "data-name": "Grupo 9035",
    transform: "translate(204.787 18.204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10090",
    "data-name": "Rect\\xE1ngulo 10090",
    width: 16.065,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9036",
    "data-name": "Grupo 9036",
    transform: "translate(194.865 24.553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10091",
    "data-name": "Rect\\xE1ngulo 10091",
    width: 4.489,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9037",
    "data-name": "Grupo 9037",
    transform: "translate(204.787 24.553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10092",
    "data-name": "Rect\\xE1ngulo 10092",
    width: 16.065,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9038",
    "data-name": "Grupo 9038",
    transform: "translate(194.865 30.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10093",
    "data-name": "Rect\\xE1ngulo 10093",
    width: 4.489,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9039",
    "data-name": "Grupo 9039",
    transform: "translate(204.787 30.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10094",
    "data-name": "Rect\\xE1ngulo 10094",
    width: 16.065,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9040",
    "data-name": "Grupo 9040",
    transform: "translate(194.865 43.599)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10095",
    "data-name": "Rect\\xE1ngulo 10095",
    width: 4.489,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9041",
    "data-name": "Grupo 9041",
    transform: "translate(204.787 43.599)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10096",
    "data-name": "Rect\\xE1ngulo 10096",
    width: 16.065,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9042",
    "data-name": "Grupo 9042",
    transform: "translate(194.865 49.948)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10097",
    "data-name": "Rect\\xE1ngulo 10097",
    width: 4.489,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9043",
    "data-name": "Grupo 9043",
    transform: "translate(204.787 49.948)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10098",
    "data-name": "Rect\\xE1ngulo 10098",
    width: 16.065,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9044",
    "data-name": "Grupo 9044",
    transform: "translate(194.865 56.296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10099",
    "data-name": "Rect\\xE1ngulo 10099",
    width: 4.489,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9045",
    "data-name": "Grupo 9045",
    transform: "translate(204.787 56.296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10100",
    "data-name": "Rect\\xE1ngulo 10100",
    width: 16.065,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9046",
    "data-name": "Grupo 9046",
    transform: "translate(194.865 68.994)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10101",
    "data-name": "Rect\\xE1ngulo 10101",
    width: 4.489,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9047",
    "data-name": "Grupo 9047",
    transform: "translate(204.787 68.994)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10102",
    "data-name": "Rect\\xE1ngulo 10102",
    width: 16.065,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9048",
    "data-name": "Grupo 9048",
    transform: "translate(194.865 75.342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10103",
    "data-name": "Rect\\xE1ngulo 10103",
    width: 4.489,
    height: 2.835,
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9049",
    "data-name": "Grupo 9049",
    transform: "translate(204.787 75.342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10104",
    "data-name": "Rect\\xE1ngulo 10104",
    width: 16.065,
    height: 2.835,
    fill: "#f4f4f4"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9084",
    "data-name": "Grupo 9084",
    transform: "translate(-165.062 63.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5973",
    "data-name": "Trazado 5973",
    d: "M283.913,311.4l41.237-41.237v-8.979l-9.67-9.67-9.094,1.049-5.488,5.488.017,5.512-3.658,3.658-5.5-.028-3.657,3.657.193,5.336-6.269,6.269-5.737.207-10.51,10.511Z",
    transform: "translate(20.169 0)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5974",
    "data-name": "Trazado 5974",
    d: "M268.382,275.172a41.236,41.236,0,1,0,41.236,41.236A41.237,41.237,0,0,0,268.382,275.172ZM257.24,339.687a12.139,12.139,0,1,1,12.139-12.139A12.139,12.139,0,0,1,257.24,339.687Z",
    transform: "translate(0 12.353)",
    fill: "url(#linear-gradient-18)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9096",
    "data-name": "Grupo 9096",
    transform: "translate(-71.231 -88.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5975",
    "data-name": "Trazado 5975",
    d: "M461.772,126.9l-25.9-5.888V99.546a3.127,3.127,0,0,0-2.741-3.053l-58.905-7.906v0l-58.91,7.906a3.128,3.128,0,0,0-2.734,3.05v21.469l-25.9,5.888a3.1,3.1,0,0,0-2.459,3V173.03c0,37.115,23.478,70.426,59.129,83.894l30.871,11.662h0l30.874-11.662c35.648-13.466,59.126-46.777,59.126-83.894V129.906A3.1,3.1,0,0,0,461.772,126.9Z",
    fill: "var(--color-primay)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9065",
    "data-name": "Grupo 9065",
    transform: "translate(284.231 88.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985",
    "data-name": "Grupo 8985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5907",
    "data-name": "Trazado 5907",
    d: "M312.587,99.544v21.469l-25.9,5.888a3.1,3.1,0,0,0-2.459,3v43.131c0,37.115,23.478,70.426,59.129,83.894l30.871,11.662v-180l-58.91,7.906A3.128,3.128,0,0,0,312.587,99.544Z",
    transform: "translate(-284.231 -88.586)",
    fill: "var(--color-light)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5908",
    "data-name": "Trazado 5908",
    d: "M390.231,268.586l30.874-11.662c35.648-13.466,59.126-46.777,59.126-83.894V129.906a3.1,3.1,0,0,0-2.459-3l-25.9-5.888V99.546a3.127,3.127,0,0,0-2.741-3.053l-58.9-7.906Z",
    transform: "translate(-300.231 -88.586)",
    fill: "var(--color-primary)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9086",
    "data-name": "Grupo 9086",
    transform: "translate(318.332 122.95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -247.1, -34.36)",
    filter: "url(#Trazado_99-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_99-2-2",
    "data-name": "Trazado 99-2",
    d: "M380.293,129.25a55.637,55.637,0,1,0,55.9,55.635h0A55.767,55.767,0,0,0,380.293,129.25Zm24.977,80.282a7.068,7.068,0,0,1-7.07,7.066.1.1,0,0,1-.032,0H362.821a7.083,7.083,0,0,1-7.1-7.063h0V186.086a7.069,7.069,0,0,1,7.07-7.066h.009v-8.234a17.7,17.7,0,0,1,35.4,0v8.234a7.078,7.078,0,0,1,7.078,7.066Zm-25.163-49.3a10.588,10.588,0,0,0-10.62,10.555v8.238h21.243v-8.216a10.605,10.605,0,0,0-10.623-10.579Zm.578,29.85a5.236,5.236,0,0,0-3.25,9.57,2.313,2.313,0,0,1,.858,2.562c-.078.239-.156.783-.233,1.023-.447,1.358.57,3.358,2.011,3.358h.447c1.434,0,2.462-2,2.013-3.358-.093-.285-.187-1.175-.279-1.46A2.083,2.083,0,0,1,383,199.44a4.755,4.755,0,0,0,2.33-5.525,5.224,5.224,0,0,0-4.646-3.838Z",
    transform: "translate(-77.29 -94.89)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBsrcomputotal);
export default __webpack_public_path__ + "static/media/img-bsrcomputotal.775710d1e548ea89b99154c467f34a4c.svg";
export { ForwardRef as ReactComponent };